module.exports = new __parcel__URL__("10438252-3.b0f53136.png").toString();